import { createGlobalStyle } from 'styled-components';
import reset from 'styled-reset';
import device from './Device';

export default createGlobalStyle`
@import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@200;300;400;500;600;700&family=Noto+Sans+KR&display=swap');
  body {
      font-family: 'Montserrat', sans-serif;
       
    font-family: 'Noto Sans KR', sans-serif;
  }
/* @font-face {
    font-family: 'Noto Sans KR', sans-serif;
    src: url('./font/SpaceGrotesk-Regular.ttf');
} */
    ${reset}
    html, body, div, span, applet, object, iframe,
h1, h2, h3, h4, h5, h6, p, blockquote, pre,
a, abbr, acronym, address, big, cite, code,
del, dfn, em, img, ins, kbd, q, s, samp,
small, strike, strong, sub, sup, tt, var,
b, u, i, center,
dl, dt, dd, ol, ul, li,
fieldset, form, label, legend,
table, caption, tbody, tfoot, thead, tr, th, td,
article, aside, canvas, details, embed, 
figure, figcaption, footer, header, hgroup, 
menu, nav, output, ruby, section, summary,
time, mark, audio, video, button {
	margin: 0;
	padding: 0;
	border: 0;
	font-size: 100%;
    font-family: 'Montserrat', sans-serif;
    font-weight: 00;
    vertical-align: baseline;
    &:focus{outline:0;}
}
/* HTML5 display-role reset for older browsers */
article, aside, details, figcaption, figure, 
footer, header, hgroup, menu, nav, section {
	display: block;
}
html, body {
    height: 100%;
}
body {
	line-height: 1;
}
ol, ul {
	list-style: none;
}
blockquote, q {
	quotes: none;
}
blockquote:before, blockquote:after,
q:before, q:after {
	content: '';
	content: none;
}
table {
	border-collapse: collapse;
	border-spacing: 0;
}
    *{
        box-sizing:border-box;
    }

    body {
        background-color:${(props) => props.theme.bgColor};
        font-size:16px;
        line-height: 1.5;
        /* letter-spacing : -0.08em; */
        @media ${device.laptop} {
            font-size:14px;
        }
        @media ${device.tablet} {
            font-size:13px;
        }
        @media ${device.phone} {
            font-size:12px;
        }
    }
    a {
        color:${(props) => props.theme.blackColor};
        text-decoration:none;
    }

    .slick-prev:before, .slick-next:before {
display: none;
}
    h1 { font-size: 2em; }
    h2 { font-size: 1.5em; }
    h3 { font-size: 1.17em; }
    h4 { font-size: 1em; }
    h5 { font-size: .83em; }
    h6 { font-size: .75em; }
    #root {
        height: 100%;
    }
`;
